<template>
  <v-app>
    <v-fade-transition appear hide-on-leave leave-absolute>
      <v-content>
        <router-view name="title" key="title-router" />
        <router-view name="default" key="site-router" />
      </v-content>
    </v-fade-transition>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "main-application",
});
</script>

<style scoped>
@font-face {
  font-family: mySolutionCenterFont;
  src: url('~@/assets/fonts/Linotype-TradeGothicLTPro.otf');
}

@font-face {
  font-family: mySolutionCenterFont-Bold;
  src: url('~@/assets/fonts/MyriadPro-Bold.otf');
}

@font-face {
  font-family: mySolutionCenterFont-It;
  src: url('~@/assets/fonts/MyriadPro-It.otf');
}
</style>
